export const ENV = {
  API_ROOT: "https://api.esocs.org.ng/api",//"https://localhost:44313/api",
  APP_NAME:"ESOCS Data Bank"
};
